var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{class:_vm.tableClass,attrs:{"role":"grid"}},[(_vm.loading)?_c('loader'):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }